<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">         
                    <v-container fill-height fluid grid-list-xl>
                        <v-layout wrap>  
                            <v-flex v-for="(pergunta, indicePergunta) in perguntasEnquete" :key="pergunta.id" sm12 xs12 md12 lg12 grid-list-md > 
                                <v-card v-if="pergunta.listaValores != null">
                                    <v-card-text>
                                        <v-flex sm12 xs12 md12 lg12 grid-list-md >                                     
                                            <div>
                                                <span class="numeroPergunta">{{pergunta.ordem}}</span>
                                                <span class="textoPergunta"> - {{aplicarTraducaoPergunta(indicePergunta)}}</span>                                            
                                            </div>                                                
                                        </v-flex>

                                        <bar-chart v-if="pergunta.dataCollection != null && pergunta.dataCollection.type == 'bar'"                                         
                                            v-model="pergunta.dataCollection" :options="barOptions" /> 

                                        <horizontal-bar-chart v-if="pergunta.dataCollection != null && pergunta.dataCollection.type == 'horizontalbar'" 
                                            v-model="pergunta.dataCollection" :options="barOptions" />                                             

                                        <doughnut-chart v-else-if="pergunta.dataCollection != null && pergunta.dataCollection.type == 'doughnut'" 
                                            v-model="pergunta.dataCollection" :options="doughnutOptions"/> 

                                        <v-divider class="mx-3" />

                                        <v-card-actions>
                                            <v-icon v-if="pergunta.dataCollection != null && pergunta.dataCollection.type != 'bar'" class="mr-2" @click="alterarGrafico(indicePergunta, 'bar')">
                                                mdi-chart-bar
                                            </v-icon>

                                            <v-icon v-if="pergunta.dataCollection != null && pergunta.dataCollection.type != 'doughnut'" class="mr-2" @click="alterarGrafico(indicePergunta, 'doughnut')">
                                                mdi-chart-arc
                                            </v-icon>     

                                            <v-icon v-if="pergunta.dataCollection != null && pergunta.dataCollection.type != 'horizontalbar'" class="mr-2" @click="alterarGrafico(indicePergunta, 'horizontalbar')">
                                                mdi-align-horizontal-left 
                                            </v-icon>                                                                                       
                                        </v-card-actions>                                        
                                    </v-card-text>
                                </v-card>
                            </v-flex> 
                        </v-layout>
                    </v-container>                         
                </material-card>
            </v-flex>
        </v-layout>            
    </v-container>
</template>

<script>
import BarChart from '@/components/material/Chart/BarChart'
import HorizontalBarChart from '@/components/material/Chart/HorizontalBarChart'
import DoughnutChart from '@/components/material/Chart/DoughnutChart'

import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import EnqueteApi from '@/api/workspace/corporativo/enquete/enquete'
import EnqueteListaValoresApi from '@/api/workspace/corporativo/enquete/listavalores'

export default {
    components: {
        "bar-chart": BarChart,
        "horizontal-bar-chart": HorizontalBarChart,
        "doughnut-chart": DoughnutChart
    },
    mixins: [ FormMixin, DateMixin ],  
    data () {
        return { 
            enquete: null,
            dataInicial: null, 
            dataFinal: null, 
            datacollection: {},
            doughnutOptions: {  
                responsive: true, 
                maintainAspectRatio: false,
            },
            barOptions: {  
                responsive: true, 
                maintainAspectRatio: false,
                legend: { display: false }
            }                
        }
    },
    computed: {  
        title () {
            if(this.enquete != null){
                const locale = localStorage.getItem("locale");
                let titulo = this.enquete.nome;

                for(let count = 0; count < this.enquete.traducao.length; count++){
                    if(locale == this.enquete.traducao[count].linguagem.codigoUnico){
                        titulo = this.enquete.traducao[count].nome;
                        break;
                    }
                }

                return titulo;
            }
            else 
                return null;
        },
        text () {
            let dates = this.$moment(this.tranformEpoch2Date(this.dataInicial)).format('L');
            return `${dates} ~ ${this.$moment(this.tranformEpoch2Date(this.dataFinal)).format('L')}`; 
        },
        perguntasEnquete(){
            if(this.enquete != null){
                return this.enquete.pergunta;
            }
            else 
                return [];            
        },                           
    },
    created(){
        this.dataInicial = this.$route.params.dataInicial;
        this.dataFinal = this.$route.params.dataFinal;
    },
    async mounted(){     
        const loading = this.showLoading();
        await this.listarEnquete();

        await this.listarAtributos();
        await this.dashboard();
        
        loading.close();
    },    
    methods:{  
        async listarEnquete(){
            const self = this;
            const enquete = await EnqueteApi.listarPorId(this.$route.params.idEnquete).catch(erro => self.showSnackbarError(erro.error));            

            if(enquete.success) {
                self.enquete = enquete.data;   
            }
            else {                        
                self.showSnackbarError(enquete.error);
                throw new Error(enquete.error[0].userMessage);
            } 
        },
        async listarAtributos(){
            const self = this;
            for(let count = 0; count < this.enquete.pergunta.length; count++){
                let pergunta = this.enquete.pergunta[count];

                if(pergunta.listaValores != null){
                    const listaValores = await EnqueteListaValoresApi.listarPorId(pergunta.listaValores.id).catch(erro => self.showSnackbarError(erro.error));            

                    if(listaValores.success) {
                        self.$set(self.enquete.pergunta[count], "listaValores", listaValores.data);
                    }
                    else {                        
                        self.showSnackbarError(listaValores.error);
                        throw new Error(listaValores.error[0].userMessage);
                    }                                 
                }
            }
        },        
        async dashboard(){
            const self = this;
            const uniqueId = `${self._uid}-dashboard`;

            let idPais = this.$route.query.idPais;
            let idEmpresa = this.$route.query.idEmpresa;
            let idDivisao = this.$route.query.idDivisao;
            let idLocalidade = this.$route.query.idLocalidade;

            const dashboard = await EnqueteApi.dashboard(this.$route.params.idEnquete, this.dataInicial, this.dataFinal, idPais, idEmpresa, idDivisao, idLocalidade).catch(erro => self.showSnackbarError(erro.error));            

            if(dashboard.success) {
                await self.montarDataSet(dashboard.data);
            }
            else {                        
                self.showSnackbarError(dashboard.error);
                throw new Error(dashboard.error[0].userMessage);
            }   
        },
        async montarDataSet(dashboard){
            for(let indicePergunta = 0; indicePergunta < this.enquete.pergunta.length; indicePergunta++){
                const pergunta = this.enquete.pergunta[indicePergunta];
                let dataCollection = {
                    type: null,
                    labels: [],
                    datasets: [{
                        label: [],
                        backgroundColor: [],
                        data: []
                    }]
                };

                if(pergunta.listaValores != null && pergunta.listaValores != undefined){
                    const listaValores = pergunta.listaValores;
                    let opcoes = [];
                    if(pergunta.indicadorMultiplaEscolha){
                        for(let indiceAtributo = 0; indiceAtributo < listaValores.atributo.length; indiceAtributo++)
                            opcoes.push(0);
                    }

                    for(let indiceAtributo = 0; indiceAtributo < listaValores.atributo.length; indiceAtributo++){
                        const color = this.getRandomColor();
                        const atributo = listaValores.atributo[indiceAtributo];

                        dataCollection.labels.push(this.aplicarTraducaoAtributo(indicePergunta, indiceAtributo));
                        const dashboardIndex = this.$_.findIndex(
                            dashboard, 
                            (d) => { 
                                return d.pergunta.id == pergunta.id && 
                                    d.enqueteListaValoresAtributo.id == atributo.id
                            }
                        );

                        if(pergunta.indicadorMultiplaEscolha){
                            dataCollection.type = "doughnut";
                            dataCollection.datasets[0].label.push(this.aplicarTraducaoAtributo(indicePergunta, indiceAtributo));
                            dataCollection.datasets[0].backgroundColor.push(color);

                            for(let contDashboard = 0; contDashboard < dashboard.length; contDashboard++){
                                const d = dashboard[contDashboard];

                                if(d.pergunta.id == pergunta.id && d.indicadorMultiplaEscolhaListaValoresAtributo != null){
                                    let flag = Math.pow(2, this.$_.parseInt(atributo.valor, 10));
                                    if(d.indicadorMultiplaEscolhaListaValoresAtributo & flag)
                                        opcoes[indiceAtributo] += d.quantidade;
                                }
                            }
                        }
                        else{
                            if(listaValores.atributo.length <= 2)
                                dataCollection.type = "doughnut";
                            else 
                                dataCollection.type = "bar";

                            dataCollection.datasets[0].label.push(this.aplicarTraducaoAtributo(indicePergunta, indiceAtributo));
                            dataCollection.datasets[0].backgroundColor.push(color);

                            if(dashboardIndex >= 0){
                                dataCollection.datasets[0].data.push(dashboard[dashboardIndex].quantidade);
                            }
                            else{
                                dataCollection.datasets[0].data.push(0);
                            }
                        }    
                    }

                    if(opcoes.length > 0)
                        dataCollection.datasets[0].data = opcoes;

                    this.$set(this.enquete.pergunta[indicePergunta], "dataCollection", dataCollection);
                }
            }
        },  
        aplicarTraducaoPergunta(indicePergunta){
            const locale = localStorage.getItem("locale");
            const pergunta = this.enquete.pergunta[indicePergunta];
            
            let descricao = pergunta.descricao;
            for(let count = 0; count < pergunta.traducao.length; count++){
                if(locale == pergunta.traducao[count].linguagem.codigoUnico){
                    descricao = pergunta.traducao[count].descricao;
                    break;
                }
            }

            return descricao;
        },
        aplicarTraducaoAtributo(indicePergunta, indiceAtributo){
            const locale = localStorage.getItem("locale");
            const atributo = this.enquete.pergunta[indicePergunta].listaValores.atributo[indiceAtributo];
            
            let descricao = atributo.descricao;
            for(let count = 0; count < atributo.traducao.length; count++){
                if(locale == atributo.traducao[count].linguagem.codigoUnico){
                    descricao = atributo.traducao[count].descricao;
                    break;
                }
            }

            return descricao;
        },    
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) 
                color += letters[Math.floor(Math.random() * 16)];

            return color;
        },
        alterarGrafico(indicePergunta, tipoGrafico){
            if(this.enquete.pergunta[indicePergunta].dataCollection.type != tipoGrafico)
            this.$set(this.enquete.pergunta[indicePergunta].dataCollection, "type", tipoGrafico);
        }         
    }
}
</script>

<style lang="scss" scoped>
// @import "../../../styles/material-dashboard/variables";
    .v-card--material {
        &__header {
            &.v-card {
                border-radius: 4px;
            }
        }
    }
    .numeroPergunta{
        font-size: 19px;  
        font-weight: bolder;
    }    
    .textoPergunta{
        font-size: 17px;  
    }    
</style>
